import { createContext, useContext } from 'react';
import { defaultNumberOfStreams } from '../../constants/streams.es.js';
var DefaultRoyaltyCalculatorContextProps = {
  numberOfStreams: defaultNumberOfStreams,
  setNumberOfStreams: function setNumberOfStreams(streams) {}
};
var RoyaltyCalculatorContext = createContext(DefaultRoyaltyCalculatorContextProps);

var useRoyaltyCalculatorContext = function useRoyaltyCalculatorContext() {
  return useContext(RoyaltyCalculatorContext);
};

export { DefaultRoyaltyCalculatorContextProps, RoyaltyCalculatorContext, useRoyaltyCalculatorContext };